import React from 'react'
import Footer from '../Footer/footer'
import Section from '../Section/section'
import { homeObj_1, homeObj_2, homeObj_3 } from '../../data'

function Home() {
  return (
    <>
      <Section{...homeObj_1} />
      <Section{...homeObj_2} />
      <Section{...homeObj_3} />
      
    </>
  )
}

export default Home;
